var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInbEventFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4949 22.65C19.712 22.65 22.3199 20.0421 22.3199 16.825C22.3199 13.6079 19.712 11 16.4949 11C13.2779 11 10.6699 13.6079 10.6699 16.825C10.6699 20.0421 13.2779 22.65 16.4949 22.65ZM14.8125 14.6603C14.8125 14.466 15.0245 14.3459 15.1911 14.4459L18.674 16.5356C18.8358 16.6327 18.8358 16.8673 18.674 16.9644L15.1911 19.0541C15.0245 19.1541 14.8125 19.034 14.8125 18.8397V14.6603Z",
    fill: "#CCCFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.95 3.89309C20.95 2.74061 20.0102 1.80078 18.8577 1.80078H4.09231C2.93983 1.80078 2 2.74061 2 3.89309V18.6585C2 19.811 2.93983 20.7508 4.09231 20.7508H9.95729C9.26694 19.6039 8.86987 18.2604 8.86987 16.8242C8.86987 12.613 12.2837 9.19922 16.4949 9.19922C18.158 9.19922 19.6968 9.73169 20.95 10.6354V3.89309ZM20.95 13.0714C19.8815 11.8042 18.2822 10.9992 16.4949 10.9992C14.4001 10.9992 12.5635 12.105 11.5371 13.7647C12.7791 12.7136 14.947 12.7283 17.4789 12.7455H17.4791H17.4793C17.8072 12.7477 18.1411 12.75 18.4799 12.75C19.3416 12.75 20.1716 12.8852 20.95 13.1355V13.0714ZM4.75293 9.30078H10.1877V10.8008H4.75293V9.30078ZM15.8529 6V7.5H4.75293V6H15.8529Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbEventFill);
export default __webpack_public_path__ + "static/media/icon-inb-event-fill.4c6db2c0dc03a3231806556078d11b73.svg";
export { ForwardRef as ReactComponent };